<div class="toast--container">
  @for (m of messages; track m) {
    <div
      class="toast--body"
      [ngClass]="{
      'toast--info': m.level === 'info',
      'toast--warn': m.level === 'warn',
      'toast--success': m.level === 'success'
    }">
      <div class="message--info">
        @if (m.heading) {
          <div>
            <strong>{{ m.heading }}</strong>
          </div>
        }
        <div data-cy="toast-message">
          {{ m.message }}
        </div>
      </div>
      <div class="button--dismiss" (click)="deleteMsg(m.timeStamp)">Dismiss</div>
    </div>
  }
</div>
